import {
  ACCESS_KEY_LOADING,
  ACCESS_KEY_SUCCESS,
  ACCESS_KEY_FAILED,
  ACCESS_KEY_CLEAR
} from "../actionTypeConstants/AccessKey";

const initialState = {
  accessKey: {
    loading: false,
    data: null,
    error: null
  }
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case ACCESS_KEY_LOADING:
      return {
        ...state,
        accessKey: { ...state.accessKey, loading: true, error: null }
      };

    case ACCESS_KEY_SUCCESS:
      return {
        ...state,
        accessKey: {
          ...state.accessKey,
          loading: false,
          data: action.result.data,
          error: null
        }
      };

    case ACCESS_KEY_FAILED:
      return {
        ...state,
        accessKey: { ...state.accessKey, loading: false, error: action.error }
      };

    case ACCESS_KEY_CLEAR:
      return { ...state, accessKey: initialState.accessKey };

    default:
      return state;
  }
}
